/**
 * Gestione Mense Backend Authentication API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { PastiNonOrdinari } from './pastiNonOrdinari';

export interface ResocontoPastiDipendenti { 
    intestazioneScuola?: string;
    numeroPastiDocenti?: number;
    numeroPastiPersonaleAta?: number;
    numeroPastiPersonaleTecnico?: number;
    numeroPastiCollaboratori?: number;
    notePastiDocenti?: string;
    notePastiPersonaleAta?: string;
    notePastiPersonaleTecnico?: string;
    notePastiCollaboratori?: string;
    numeroMinimoPastiDaFatturare?: number;
    pastiNonOrdinariDocenti?: Array<PastiNonOrdinari>;
    pastiNonOrdinariPersonaleAta?: Array<PastiNonOrdinari>;
    pastiNonOrdinariPersonaleTecnico?: Array<PastiNonOrdinari>;
    pastiNonOrdinariCollaboratori?: Array<PastiNonOrdinari>;
}